<div class="integer-answer"><app-icon [size]="'20'" [glyph]="'pencil'"></app-icon> 1,2,3</div>
